import * as React from "react";
import { Query, QueryResult } from "react-apollo";
import {
  GetRoleByNameQuery,
  GetRoleByNameQueryVariables
} from "../../__generated__/types";
import { ROLE_BY_NAME_QUERY } from "./queries";

export class RoleQuery extends Query<
  GetRoleByNameQuery,
  GetRoleByNameQueryVariables
> {}

interface Props {
  name: string;
  children(props: QueryResult<GetRoleByNameQuery>): JSX.Element | null;
}

export default ({ children, name }: Props) => {
  return (
    <RoleQuery query={ROLE_BY_NAME_QUERY} variables={{ name }}>
      {result => children(result)}
    </RoleQuery>
  );
};



// WEBPACK FOOTER //
// ./src/queries/RoleQuery/RoleQuery.tsx